import React from "react";
import styled from "styled-components";
import { FontWeight } from "@glossy";
import { Color } from "@glossy/colors";
import { message } from "@glossy/theme";
import { GlossyTheme } from "@glossy/theme/types";

export const BADGE_TYPES = ["info", "success", "danger"] as const;
type BadgeType = typeof BADGE_TYPES[number];

const getColor = (props: { type: BadgeType; theme: GlossyTheme }) =>
  message(
    props,
    props.type === "success"
      ? "success"
      : props.type === "danger"
      ? "error"
      : "info"
  );
const Badge = styled.div<{
  type: BadgeType;
}>`
  box-sizing: border-box;
  color: ${Color.White};
  background-color: ${(props) => getColor(props)};
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  border-radius: 20px;
  text-align: center;
  font-size: 11px;
  font-weight: ${FontWeight.Normal};
  display: inline-block;
  padding: 0 4px;
`;

interface IProps {
  children: React.ReactNode;
  color?: BadgeType;
}

/**
 * Display changing info, like counters, in a small rounded pill
 */
const UiKitChipBadge = ({ children, color = "info" }: IProps) => (
  <Badge type={color}>{children}</Badge>
);

export default UiKitChipBadge;
